
<div style="margin-left: 75px;">
    <!-- site dialog -->
    <d-site
        v-if     = "items"
        v-model  = "showSite"
        :site-id = "siteId"
    />
    <!-- site dialog -->

    <d-contract-zus-edit
        v-if         = "zus"
        v-model      = "create"
        :contract-id = "-1"
        :company-id  = "zus.id"
        @saved       = "onContractSaved"
    />

    <company-app-bar
        title       = "ZÜS"
        :categories = "['zus']"
        @search       = "onSearch"
    />

    <div class="v-flex">
        <c-index
            :items="items"
            :enable-search="false"
            :criterion="criteria"
            :filter="indexFilter"
            :miminize      = "false"
            @clear-filter = "onClearFilter"
            @selected="onZus"
            style="position: relative; margin-right: 75px;"
        >
            <template v-slot:item="{ item }">
                <div>
                    {{ item.name }}
                </div>
                <v-spacer></v-spacer>
                <company-roles
                    :ignore="5"
                    :item="item"
                />
            </template>
            <template v-slot:detail="{ item }" >
                <div v-if="item" class="mt-1 h-100" style="width: calc(100% + 12px);">
                    <v-row class="no-frame pl-4 h-100">
                        <v-col class="no-frame col-4 h-100 pr-1">
                            <c-servicepartner-edit
                                v-if     = "zus"
                                :company = "zus"
                                style    = "margin-top: 9px;"
                            />

                            <service-customer-list
                                style    = "margin-top: 14px; height: calc(100% - 570px);"
                                v-if     = "zus"
                                @customer="onCompanyCustomer"
                                ref      = "customerList"
                            />
                        </v-col>

                        <v-col
                            class  = "no-frame pl-2 pr-0 col-4"
                            :class = "item.show ? 'pl-4' : 'pl-0'"
                        >
                            <c-flip-card
                                v-model="flip"
                                color="white--text" :top="17" :right="90"
                            >
                                <template v-slot:front>
                                    <v-card-iterator
                                        label          = "Verträge"
                                        v-if           = "contracts.items"
                                        :items         = "contracts.items"
                                        :columns       = "1"
                                        :item-height   = "109"
                                        :filter-height = "150"
                                        :enable-search = "true"
                                        :filter        = "textfilter"
                                        class          = "w-100"
                                        ref            = "iterator"
                                    >
                                        <template v-slot:toolbar>
                                            <div class="v-flex">
                                                <c-header-button label="ZÜS" @click = "onZusCreate" :tooltip="$t('contract.create.zus')" />
                                            </div>
                                        </template>
                                        <template v-slot:filter>
                                            <c-contract-zus-card-filter
                                                v-model = "filter"
                                                @input  = "onFilterChanged"
                                                class   = "mt-1 mb-n1"
                                            />
                                        </template>
                                        <template v-slot:card="{ item }">
                                            <c-contract-zus-card
                                                :contract   = "item"
                                                :background = "background(contracts.selected, item)"
                                                @saved      = "onContractSaved(item)"
                                                @selected   = "onContractSelected(item)"
                                            />
                                        </template>
                                    </v-card-iterator>

                                </template>
                                <template v-slot:back>
                                    <contact-card-iterator
                                        :items       = "contacts.items"
                                        :company-id  = "zus ? zus.id : null"
                                        :contract-id = "contracts.selected"
                                        :customer-id = "customer.detail ? customer.detail.id : null"
                                        :combine-allowed = "true"
                                        @selected    = "onContactSelected"
                                        @zoom        = "contacts.zoom = true"
                                        class        = "w-100"
                                    />
                                </template>
                            </c-flip-card>
                        </v-col>

                        <v-col class="no-frame pl-2 col-4" :class="item.show ? 'col-4' : 'col-3'">
                            <c-site-card-iterator
                                v-if      = "zus"
                                role      = "ZUS"
                                :customer = "customer.detail"
                                :contract = "contracts.selected"
                                :contact  = "contacts.selected"
                                :contract-height = "150"
                                class     = "w-100"
                                @site     = "onSite"
                                ref       = "siteIterator"
                            >
                                <template v-slot:editor="{ site }">
                                    <c-contract-zus-editor
                                        :unit = "site"
                                    />
                                </template>
                            </c-site-card-iterator>
                        </v-col>
                    </v-row>
                </div>
            </template>

        </c-index>
    </div>
</div>
